import { Dispatch, SetStateAction } from 'react';

import { useLiquiditySourcesStore } from '@/store/liquiditySources';

import { fontStyles } from '@/styles/typography';

import { ChevronDownSmallIcon } from '@/ui/Icons/ChevronDownSmallIcon';

import { MenuId } from '../../index';
import { SectionBody, SectionHeading } from '../../Section';

interface LiquiditySourcesSectionProps {
  /** ID of the current network. */
  chainId: number;
  /** Callback that updates the current menu. */
  setCurrentMenu: Dispatch<SetStateAction<MenuId>>;
}
/**
 * Liquidity sources settings section.
 */
export const LiquiditySourcesSection = ({
  chainId,
  setCurrentMenu,
}: LiquiditySourcesSectionProps): React.ReactElement | null => {
  // state
  const { total, selected } = useLiquiditySourcesStore(
    (state) => state.liquiditySources?.[chainId] || {},
  );

  // exit early if there are no sources for the current chain
  if (!total || !selected) return null;

  const onClick = () => {
    setCurrentMenu(MenuId.LIQUIDITY_SOURCES);
  };

  return (
    <>
      <SectionHeading title="Liquidity sources" isAltered={selected !== total}>
        Select which liquidity source to include or exclude from the routing.
      </SectionHeading>

      <SectionBody>
        <button
          className={fontStyles({
            variant: 'LABEL_MD',
            class:
              'flex cursor-pointer transition-all duration-200 bg-token-alphalight-200 items-center rounded-sm border-0 justify-between p-3 w-full hover:bg-token-alphalight-300',
          })}
          onClick={onClick}
        >
          <div className="flex justify-between w-full">
            <div className="flex justify-between items-center">Select</div>

            <span className="pl-2">
              {selected} / {total}
            </span>
          </div>

          <ChevronDownSmallIcon className="transform -rotate-90" />
        </button>
      </SectionBody>
    </>
  );
};
